<dialog #dialog class="modal-backdrop" aria-modal="true" aria-labelledby="sepa-modal-title" (cancel)="$event.preventDefault(); onClose()">
  <div class="modal-panel">

    <!-- Header -->
    <div class="modal-header">
      <h2 id="sepa-modal-title">{{ 'sepaModal.title' | t }}</h2>
      <button class="modal-close-btn" type="button" (click)="onClose()" [attr.aria-label]="'modalCommon.closeAria' | t">&times;</button>
    </div>

    <!-- Body -->
    <div class="modal-body">

      <div class="sepa-info-box">
        {{ 'sepaModal.info' | t }}
      </div>

      @if (showDevHelper) {
        <div class="dev-helper-box" role="note">
          <div class="dev-helper-head">{{ 'modalCommon.devDataTitle' | t }}</div>
          <div class="dev-helper-body">
            {{ 'sepaModal.devBody' | t }} <code>{{ devTestIban }}</code>
          </div>
          <button type="button" class="btn-dev-fill" (click)="insertTestData()">
            {{ 'modalCommon.insertTestData' | t }}
          </button>
        </div>
      }

      <form class="sepa-form" novalidate (ngSubmit)="onSubmit()">

        <!-- IBAN -->
        <div class="form-group">
          <label for="sepa-iban">IBAN <span class="required">*</span></label>
          <div class="iban-wrapper">
            <input
              id="sepa-iban"
              type="text"
              placeholder="DE89 3704 0044 0532 0130 00"
              [value]="ibanFormatted()"
              (input)="onIbanInput($event)"
              name="iban"
              autocomplete="off"
              spellcheck="false"
              maxlength="42" />
            @if (submitAttempted()) {
              @if (ibanValid()) {
                <span class="iban-icon iban-icon--valid">✓</span>
              } @else {
                <span class="iban-icon iban-icon--invalid">✗</span>
              }
            }
          </div>
          @if (submitAttempted() && !ibanValid()) {
            <span class="field-error">{{ 'sepaModal.ibanError' | t }}</span>
          }
        </div>

        <!-- Kontoinhaber -->
        <div class="form-group">
          <span>{{ 'sepaModal.accountHolder' | t }}</span>
          <strong id="sepa-kontoinhaber">{{ accountHolder() }}</strong>
        </div>

        <!-- Abbuchungstag -->
        <div class="form-group">
          <label for="sepa-abbuchungstag">{{ 'modalCommon.debitDay' | t }} <span class="required">*</span></label>
          <select
            id="sepa-abbuchungstag"
            [ngModel]="abbuchungstag()"
            (ngModelChange)="abbuchungstag.set($event)"
            name="abbuchungstag"
            required>
            <option value="" disabled>{{ 'modalCommon.choose' | t }}</option>
            <option value="1">{{ 'modalCommon.firstOfMonth' | t }}</option>
            <option value="15">{{ 'modalCommon.fifteenthOfMonth' | t }}</option>
          </select>
        </div>

        <!-- Mandat-Checkbox -->
        <div class="mandate-section">
          <input
            id="sepa-mandat"
            type="checkbox"
            class="mandate-checkbox"
            [ngModel]="mandatAccepted()"
            (ngModelChange)="mandatAccepted.set($event)"
            name="mandatAccepted" />
          <label for="sepa-mandat" class="mandate-text">
            {{ 'sepaModal.mandateText' | t }}
          </label>
        </div>

      </form>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="onClose()">{{ 'common.cancel' | t }}</button>
      <button
        type="button"
        class="btn-submit"
        (click)="onSubmit()">
        {{ 'sepaModal.submit' | t }}
      </button>
    </div>

  </div>
</dialog>
